// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"f1-z","colorTextValue":"g1-z","swatches":"h1-z","collapseLink":"i1-z","isCollapsed":"j1-z","dropdown":"k1-z","disabled":"l1-z"};